import * as React from 'react';

import { ExperienceOfferingDetails } from 'components/business/offering/ExperienceOfferingDetails';
import { consumer } from '@tock/coretypes';
import { isOfferingEventType } from 'utils/offerings';
import EventOfferingDetails from './EventOfferingDetails';

export interface OfferingDetailsProps {
  business: consumer.IBusinessConfig;
  offering: consumer.Offering;
  isShowingOnBusinessPage?: boolean;
  onNavigateToExperience?(event: consumer.Offering, nextAvailableDate?: string): void;
  linkTo?: string;
  onClick?(): void;
  remainingTickets?: number;
  label?: string;
  descriptionCutoffLength?: number;
  showExperienceImages?: boolean;
  isReschedule?: boolean;
}

export const OfferingDetails: React.FunctionComponent<OfferingDetailsProps> = (
  props: OfferingDetailsProps
) => {
  const { offering } = props;
  return isOfferingEventType(offering) ? (
    <EventOfferingDetails {...props} cutoffLength={props.descriptionCutoffLength} />
  ) : (
    <ExperienceOfferingDetails {...props} cutoffLength={props.descriptionCutoffLength} />
  );
};
